import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

import { IStateCart } from "@/apps/merchant3/models/IStateCart";
import { EContract } from "@/apps/merchant3/models/IStateContract";

export default {
  namespaced: true,
  state: {
    attempts: 0,
    allDevices: [],
    contractVerballyAccepted: EContract.PENDING,
    deviceBrands: [],
    hasReceivedWelcomeCall: EContract.NO,
    lastPersonRegistrationTag: null,
    pricing: [],
    selectedDeviceModels: [],
    selectedDeviceModelsDropdown: [],
    welcomeCallRequired: null,
    uniqueRequestList: [],
  } as unknown as IStateCart,
  mutations,
  actions,
  getters,
};
